<template>
  <div class="gln-actions">
    <v-btn
      icon
      small
      :disabled="isLoading"
      :title="$vuetify.lang.t('$vuetify.action.edit')"
      @click="$emit('edit')"
    >
      <v-icon small>mdi-pencil</v-icon>
    </v-btn>

    <v-btn
      icon
      small
      :disabled="!action || isLoading"
      :title="actionLabel"
      @click="$emit('remove')"
    >
      <v-icon small>{{ actionIcon }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { getGlnAction } from "@/helpers/gln";

export default {
  props: {
    gln: {
      type: Object,
      required: true,
    },
    loadingId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    isLoading() {
      return this.loadingId === this.gln.id;
    },
    action() {
      return getGlnAction(this.gln);
    },
    actionLabel() {
      return this.action
        ? this.$vuetify.lang.t(`$vuetify.action.${this.action.key}`)
        : "";
    },
    actionIcon() {
      return this.action ? this.action.icon : "mdi-delete";
    },
  },
};
</script>

<style scoped>
.gln-actions {
  display: flex;
  flex-shrink: 0;
  align-items: center;
}
</style>
